import React from "react";

const SectionHeader = ({ title, actions }) => (
  <div className="flex flex-wrap mb-8 mt-8 py-4 px-8 border rounded bg-white items-center">
    <div className="flex-grow">
      <h2 className="text-18 font-medium" style={{ lineHeight: "32px" }}>
        {title}
      </h2>
    </div>
    {!!actions && <div className="self-end">{actions}</div>}
  </div>
);

export default SectionHeader;
